import { AuthGuardProps } from "./Guard.types";
import ResetGuard from "./ResetGuard";
import { useEffect } from "react";
import { useAuth } from "./useAuth";

export default function AuthGuard({ children }: AuthGuardProps) {
  const { refreshAuth, loading, user } = useAuth();

  useEffect(() => {
    if (user && user.auth) {
      refreshAuth({ refresh_token: user.auth.refresh_token });
    }
  }, []);

  return user ? children : <ResetGuard to="login" />;

  // TODO(np): Implement correct supabase refresh session subscription

  /* loading ? (
    <Div classNames={["flex1", "minH-{100%}", "bgNeutralDarkerDark", "justifyContentCenter", "alignItemsCenter"]}>
    <Loader isLoading={loading} />
    </Div>
    ) : */
}
